import React, { Component } from 'react';
import {
    Container, Button, Row, Col, FormGroup, Form, Input, Label, Modal, ModalHeader, ModalBody
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faGripLines, faCheck, faTrashAlt, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import ReactDragListView from 'react-drag-listview';
import ConfirmButton from '../Modal/ConfirmButton';

class Marketing2ConfigureCampaign extends Component {

    constructor(props) {
        super(props);
        this.canEdit = this.props.campaign.companies === 0;
        this.state = {
            showModal: false
        }
    }

    getFlowConditionKey = (flowConditionKey) => {
        if (this.props.systemDemographics == null || this.props.systemDemographics.length === 0) return "";
        return (this.props.systemDemographics.filter(item => item.ID === parseInt(flowConditionKey))[0] != null && this.props.systemDemographics.filter(item => item.ID === parseInt(flowConditionKey))[0].type != null) ? this.props.systemDemographics.filter(item => item.ID === parseInt(flowConditionKey))[0].type : '';
    }

    getFlowConditionValue = (flowConditionKey, flowConditionValue) => {
        if (this.props.systemDemographics == null || this.props.systemDemographics.length === 0) return "";
        try {
            return this.props.systemDemographics.filter(item => item.ID === parseInt(flowConditionKey))[0].list.filter(listItem => listItem.ID === parseInt(flowConditionValue))[0].description;
        } catch (e) {
            console.log('error', e)
            return "";
        }
    }

    displayCampaignComponents = (campaignObj, isSubCampaign) => {
        if (campaignObj.components == null) return <></>;
        return <Row className={"campaign mt-3 " + (isSubCampaign ? "subCampaign" : "")}>
            <Col className='mt-0 mx-0'>
                {campaignObj.components.map(component => {
                    if (component.isActivity) {
                        return this.displayActivity({
                            active: component.active,
                            auth0: component.auth0,
                            category: component.category,
                            categoryItemID: component.categoryItemID,
                            componentID: component.componentID,
                            duration: component.duration,
                            order: component.order,
                            notes: component.notes,
                            reminder: component.reminder,
                            snooze: component.snooze,
                            timestamp: component.timestamp,
                            isActivity: true
                        }, isSubCampaign)
                    } else if (component.isDelay) {
                        return this.displayDelay({
                            active: component.active,
                            auth0: component.auth0,
                            componentID: component.componentID,
                            duration: component.duration,
                            order: component.order,
                            timestamp: component.timestamp,
                            isDelay: true
                        }, isSubCampaign)
                    } else if (component.isFlow) {
                        return this.displayFlow({
                            active: component.active,
                            auth0: component.auth0,
                            campaign: component.campaign,
                            componentID: component.componentID,
                            duration: component.duration,
                            flowConditionKey: component.flowConditionKey,
                            flowConditionValue: component.flowConditionValue,
                            toID: component.toID,
                            order: component.order,
                            timestamp: component.timestamp,
                            isFlow: true
                        }, isSubCampaign)
                    } else if (component.isSkip) {
                        return this.displaySkip({
                            active: component.active,
                            auth0: component.auth0,
                            campaign: component.campaign,
                            componentID: component.componentID,
                            duration: component.duration,
                            flowConditionKey: component.flowConditionKey,
                            flowConditionValue: component.flowConditionValue,
                            toID: component.toID,
                            order: component.order,
                            timestamp: component.timestamp,
                            isSkip: true
                        }, isSubCampaign)
                    } else {
                        return <></>
                    }
                })
                }
            </Col>
        </Row>
    }

    displaySkipComponent = (toID) => {
        if (toID === 0) return 'End Current Campaign and Resume Next';
        if (toID === -1) return 'End All Campaigns';
        const index = this.props.campaign.components.findIndex(item => item.componentID === parseInt(toID));
        return (index > 0) ? this.displayTitle(this.props.campaign.components[index], true) : "";
        // return (index > -1) ? this.props.campaign.components[index].order / 10 : "";
    }

    displayTitle = (obj, text) => {
        if (text) {
            if (obj.isActivity) {
                return `${obj.category} / ${this.getItem(obj)}`;
            } else if (obj.isDelay) {
                return `Wait ${obj.duration} Days`;
            } else if (obj.isFlow) {
                return (obj.flowConditionKey != null && obj.flowConditionKey !== '') ? `If ${this.getFlowConditionKey(obj.flowConditionKey)} = ${this.getFlowConditionValue(obj.flowConditionKey, obj.flowConditionValue)} then execute ${this.displaySubcampaignInfo(obj).name}` : `Execute ${this.displaySubcampaignInfo(obj).name}`;
            } else if (obj.isSkip) {
                return (obj.flowConditionKey != null && obj.flowConditionKey !== '') ? `If ${obj.flowConditionKey} = ${parseInt(obj.flowConditionValue) === 1 ? 'Yes' : 'No'} then skip to step ${this.displaySkipComponent(obj.toID)}` : `Skip to step ${this.displaySkipComponent(obj.toID)}`;
            }
        } else {
            if (obj.isActivity) {
                return <>{obj.category} / {this.getItem(obj)}</>;
            } else if (obj.isDelay) {
                return <>Wait <span className='font-weight-bold'>{obj.duration} Days</span></>;
            } else if (obj.isFlow) {
                return (obj.flowConditionKey != null && obj.flowConditionKey !== '') ? <>If <span className='font-weight-bold'>{this.getFlowConditionKey(obj.flowConditionKey)}</span> = <span className='font-weight-bold'>{this.getFlowConditionValue(obj.flowConditionKey, obj.flowConditionValue)}</span> then execute <span className='font-weight-bold'>{this.displaySubcampaignInfo(obj).name}</span></> : <>Execute <span className='font-weight-bold'>{this.displaySubcampaignInfo(obj).name}</span></>;
            } else if (obj.isSkip) {
                return (obj.flowConditionKey != null && obj.flowConditionKey !== '') ? <>If <span className='font-weight-bold'>{obj.flowConditionKey}</span> = <span className='font-weight-bold'>{parseInt(obj.flowConditionValue) === 1 ? 'Yes' : 'No'}</span> then skip to step <span className='font-weight-bold'>{this.displaySkipComponent(obj.toID)}</span></> : <>Skip to step <span className='font-weight-bold'>{this.displaySkipComponent(obj.toID)}</span></>
            }
        }
    }

    getItem = (activityObj) => {
        switch (activityObj.category) {
            case "Email":
                const emailIndex = this.props.emails.findIndex(email => email.ID === activityObj.categoryItemID);
                return emailIndex > -1 ? this.props.emails[emailIndex].Name : '';
            case "Call":
                const callIndex = this.props.calls.findIndex(call => call.ID === activityObj.categoryItemID);
                return callIndex > -1 ? this.props.calls[callIndex].Name : '';
            case "Invitation":
                const invitationIndex = this.props.invitations.findIndex(invitation => invitation.ID === activityObj.categoryItemID);
                return invitationIndex > -1 ? this.props.invitations[invitationIndex].Name : '';
            case "Other":
                return String(activityObj.notes).length > 100 ? String(activityObj.notes).substring(0, 100) + '...' : activityObj.notes;
            default:
                return "";
        }
    }

    displayActivity = (activityObj, isSubCampaign) => {
        return <Row key={activityObj.componentID} className="campaignComponent" onClick={() => this.props.onEditComponent(activityObj.componentID, isSubCampaign)}>
            {!isSubCampaign && this.props.editComponent.componentID === 0 && this.canEdit && <div className='campaignDragContainer'><FontAwesomeIcon icon={faGripLines} /></div>}
            {!isSubCampaign && this.props.editComponent.componentID > 0 && <div className='campaignDragContainer'><h3 className='m-0 p-0'>{activityObj.order / 10}</h3></div>}
            {this.props.editComponent.componentID !== activityObj.componentID ?
                <Col className={`campaignActivity ${!activityObj.active ? 'campaignInactive' : ''} font-weight-bold my-${(isSubCampaign ? '1' : '2')} p-${(isSubCampaign ? '1 subCampaign' : '3')} ml-3`}>
                    {this.displayTitle(activityObj)}
                </Col>
                :
                <>
                    <Col className={`campaignActivity ml-3 px-4 py-2 my-2`}>
                        <Row className='my-2'>
                            <Input
                                name="category"
                                value={this.props.editComponent.category}
                                disabled={!this.canEdit}
                                onChange={this.props.onChange}
                                type="select"
                            >
                                <option value="">Category</option>
                                <option>Email</option>
                                <option>Call</option>
                                <option>Invitation</option>
                                <option>Other</option>
                            </Input>
                        </Row>
                        {this.props.editComponent.category != null && this.props.editComponent.category !== '' && this.props.editComponent.category !== 'Other' && <Row className='my-2'>
                            <Input
                                name="categoryItemID"
                                value={this.props.editComponent.categoryItemID}
                                disabled={!this.canEdit}
                                onChange={this.props.onChange}
                                type="select"
                            >
                                <option value="">Activity</option>
                                {this.props.editComponent.category === 'Email' && this.props.emails.map(email => (
                                    <option value={email.ID}>{email.Name}</option>
                                ))}
                                {this.props.editComponent.category === 'Call' && this.props.calls.map(call => (
                                    <option value={call.ID}>{call.Name}</option>
                                ))}
                                {this.props.editComponent.category === 'Invitation' && this.props.invitations.map(invitation => (
                                    <option value={invitation.ID}>{invitation.Name}</option>
                                ))}
                            </Input>
                        </Row>}
                        <Row className='my-2'>
                            <Input
                                type="textarea"
                                name="notes"
                                disabled={!this.canEdit}
                                placeholder='Notes'
                                onChange={this.props.onChange}
                                value={this.props.editComponent.notes}
                                rows={6}
                            />
                        </Row>
                        {this.props.checkPermission('Reassign Workflow Task') && <Row className='my-2'>
                            <Input
                                type="select"
                                name="auth0"
                                onChange={this.props.onChange}
                                // disabled={!this.canEdit}
                                value={this.props.editComponent.auth0}
                            >
                                <option value="">Default to Previous Assignee</option>
                                {this.props.users.map(user => (
                                    <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                                ))}
                            </Input>
                        </Row>}
                        <Row className='my-2'>
                            <Form inline>
                                <FormGroup>
                                    <Input
                                        className='mr-2'
                                        name="reminder"
                                        disabled={!this.canEdit}
                                        value={this.props.editComponent.reminder}
                                        onChange={this.props.onChange}
                                        type="select"
                                    >
                                        <option>REMINDER</option>
                                        <option value={1}>1 Day</option>
                                        <option value={2}>2 Days</option>
                                        <option value={3}>3 Days</option>
                                        <option value={4}>4 Days</option>
                                        <option value={5}>5 Days</option>
                                        <option value={7}>1 Week</option>
                                        <option value={14}>2 Weeks</option>
                                        <option value={21}>3 Weeks</option>
                                        <option value={30}>1 Month</option>
                                        <option value={60}>2 Months</option>
                                        <option value={90}>3 Months</option>
                                        <option value={120}>4 Months</option>
                                        <option value={150}>5 Months</option>
                                        <option value={180}>6 Months</option>
                                        <option value={365}>1 Year</option>
                                        <option value={730}>2 Years</option>
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Input
                                        className='mx-2'
                                        name="snooze"
                                        disabled={!this.canEdit}
                                        value={this.props.editComponent.snooze}
                                        onChange={this.props.onChange}
                                        type="select"
                                    >
                                        <option>SNOOZE</option>
                                        <option value={1}>1 Day</option>
                                        <option value={2}>2 Days</option>
                                        <option value={3}>3 Days</option>
                                        <option value={4}>4 Days</option>
                                        <option value={5}>5 Days</option>
                                        <option value={7}>1 Week</option>
                                        <option value={14}>2 Weeks</option>
                                        <option value={21}>3 Weeks</option>
                                        <option value={30}>1 Month</option>
                                        <option value={60}>2 Months</option>
                                        <option value={90}>3 Months</option>
                                        <option value={120}>4 Months</option>
                                        <option value={150}>5 Months</option>
                                        <option value={180}>6 Months</option>
                                        <option value={365}>1 Year</option>
                                        <option value={730}>2 Years</option>
                                    </Input>
                                </FormGroup>
                            </Form>
                        </Row>
                    </Col>
                    <Col md={3} className={`campaignActivityControls p-2 text-right my-2`}>
                        <Row>
                            <Col className=''>
                                {this.canEdit && <Button
                                    className="mx-1 mt-2"
                                    color="success"
                                    onClick={(e) => this.props.handleSaveComponent(e, 'isActivity', this.props.editComponent.order)}
                                    title="Save Component"
                                    disabled={(this.props.editComponent.category == null || this.props.editComponent.category === '' || this.props.editComponent.categoryItemID == null || this.props.editComponent.categoryItemID === '' || this.props.editComponent.categoryItemID === 0) && this.props.editComponent.category !== 'Other'}
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>}
                                {!this.canEdit && <Button
                                    className="mx-1 mt-2"
                                    color="success"
                                    onClick={(e) => this.props.handleSaveComponent(e, 'isActivity', this.props.editComponent.order)}
                                    title="Save Assignee"
                                    disabled={this.props.editComponent.auth0 === activityObj.auth0}
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>}
                                {this.canEdit && <ConfirmButton className="mx-1 mt-2 px-3" color="danger" onClick={this.props.handleDeleteComponent} title="Delete Component">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </ConfirmButton>}
                                <Button className="mx-1 mt-2 px-3" color="secondary" onClick={this.props.onCancelEditComponent} title="End Configure Component">
                                    <FontAwesomeIcon icon={faTimes} />
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='px-4 py-0 text-right'>
                                <Label><Input
                                    type="checkbox"
                                    name="active"
                                    disabled={!this.canEdit}
                                    onChange={this.props.onChange}
                                    checked={this.props.editComponent.active}
                                /> Active</Label>
                            </Col>
                        </Row>
                    </Col>
                </>
            }
        </Row>
    }

    displayDelay = (delayObj, isSubCampaign) => {
        return <Row key={delayObj.componentID} className={this.props.editComponent.componentID !== delayObj.componentID ? 'campaignComponent' : ''} onClick={() => this.props.onEditComponent(delayObj.componentID, isSubCampaign)}>
            {!isSubCampaign && this.props.editComponent.componentID === 0 && this.canEdit && <div className='campaignDragContainer'><FontAwesomeIcon icon={faGripLines} /></div>}
            {!isSubCampaign && this.props.editComponent.componentID > 0 && <div className='campaignDragContainer'><h3 className='m-0 p-0'>{delayObj.order / 10}</h3></div>}
            {this.props.editComponent.componentID !== delayObj.componentID ?
                <Col className={`campaignDelay ${!delayObj.active ? 'campaignInactive' : ''} my-${(isSubCampaign ? '1' : '2')} p-${(isSubCampaign ? '1 subCampaign' : '3')} ml-3`}>
                    {this.displayTitle(delayObj)}
                </Col>
                :
                <>
                    <Col className={`campaignDelay ml-3 px-4 py-2 my-2`}>
                        <Row className='my-2'>
                            <Form inline>
                                <FormGroup>
                                    <Label>Delay
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Input
                                        className='mx-2'
                                        type="number"
                                        name="duration"
                                        min={0}
                                        step={1}
                                        disabled={!this.canEdit}
                                        value={parseInt(this.props.editComponent.duration)}
                                        // value={parseInt(this.props.editComponent.duration) / parseInt(this.props.editComponent.durationType) }
                                        onChange={this.props.onChange}
                                    // onChange={(e) => {
                                    //     this.props.onChange({
                                    //         target: {
                                    //             name: 'duration',
                                    //             value: parseInt(this.props.editComponent.durationType) * parseInt(e.target.value)
                                    //         }
                                    //     })
                                    // }}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Days
                                    </Label>
                                </FormGroup>
                                {/* <FormGroup inline>
                                <Input
                                    className="mx-2"
                                    type="select"
                                    value={this.props.editComponent.durationType}
                                    onChange={(e) => {
                                        this.props.onChange({
                                            target: {
                                                name: 'durationType',
                                                value: parseInt(e.target.value)
                                            }
                                        }, () => {
                                            this.props.onChange({
                                                target: {
                                                    name: 'duration',
                                                    value: parseInt(this.props.editComponent.durationType) * parseInt(this.props.editComponent.duration)
                                                }
                                            })
                                        })
                                    }}
                                >
                                    <option value={1}>Minutes</option>
                                    <option value={60}>Hours</option>
                                    <option value={1440}>Days</option>
                                </Input>
                            </FormGroup> */}
                            </Form>
                        </Row>
                        <Row className='my-2'>
                            <Input
                                type="textarea"
                                name="notes"
                                placeholder='Notes'
                                onChange={this.props.onChange}
                                disabled={!this.canEdit}
                                value={this.props.editComponent.notes}
                                rows={6}
                            />
                        </Row>
                        {this.props.checkPermission('Reassign Workflow Task') && <Row className='my-2'>
                            <Input
                                type="select"
                                name="auth0"
                                onChange={this.props.onChange}
                                // disabled={!this.canEdit}
                                value={this.props.editComponent.auth0}
                            >
                                <option value="">Default to Previous Assignee</option>
                                {this.props.users.map(user => (
                                    <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                                ))}
                            </Input>
                        </Row>}
                    </Col>
                    <Col md={3} className={`campaignDelayControls p-2 text-right my-2`}>
                        <Row>
                            <Col className=''>
                                {this.canEdit && <Button
                                    className="mx-1 mt-2"
                                    color="success"
                                    onClick={(e) => this.props.handleSaveComponent(e, 'isDelay', this.props.editComponent.order)}
                                    title="Save Component"
                                    disabled={parseInt(this.props.editComponent.duration) <= 0 || isNaN(parseInt(this.props.editComponent.duration))}
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>}
                                {!this.canEdit && <Button
                                    className="mx-1 mt-2"
                                    color="success"
                                    onClick={(e) => this.props.handleSaveComponent(e, 'isDelay', this.props.editComponent.order)}
                                    title="Save Assignee"
                                    disabled={this.props.editComponent.auth0 === delayObj.auth0}
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>}
                                {this.canEdit && <ConfirmButton className="mx-1 mt-2 px-3" color="danger" onClick={this.props.handleDeleteComponent} title="Delete Component">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </ConfirmButton>}
                                <Button className="mx-1 mt-2 px-3" color="secondary" onClick={this.props.onCancelEditComponent} title="End Configure Component">
                                    <FontAwesomeIcon icon={faTimes} />
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='px-4 py-0 text-right'>
                                <Label><Input
                                    type="checkbox"
                                    name="active"
                                    disabled={!this.canEdit}
                                    onChange={this.props.onChange}
                                    checked={this.props.editComponent.active}
                                /> Active</Label>
                            </Col>
                        </Row>
                    </Col>
                </>
            }
        </Row>
    }

    displayFlow = (flowObj, isSubCampaign) => {
        // console.log('flow',flowObj)
        return <Row key={flowObj.componentID} className='campaignComponent' onClick={() => this.props.onEditComponent(flowObj.componentID, isSubCampaign)}>
            {!isSubCampaign && this.props.editComponent.componentID === 0 && this.canEdit && <div className='campaignDragContainer'><FontAwesomeIcon icon={faGripLines} /></div>}
            {!isSubCampaign && this.props.editComponent.componentID > 0 && <div className='campaignDragContainer'><h3 className='m-0 p-0'>{flowObj.order / 10}</h3></div>}
            {this.props.editComponent.componentID !== flowObj.componentID ?
                <Col className={`my-${(isSubCampaign ? '1' : '2')} ${!flowObj.active ? 'campaignInactive' : ''} py-${(isSubCampaign ? '1 subCampaign' : '3')} ml-3 ` + this.displaySubcampaignInfo(flowObj).class}>
                    {this.displayTitle(flowObj)}
                    {flowObj.campaign != null ? this.displayCampaignComponents(flowObj.campaign, true) : <></>}
                </Col>
                :
                <>
                    <Col className={`campaignFlowLogic ml-3 px-4 py-2 my-2`}>
                        <Row className='my-2'>
                            <Form inline>
                                <FormGroup>
                                    <Label>(Optional) If
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Input
                                        className='mx-2'
                                        name="flowConditionKey"
                                        disabled={!this.canEdit}
                                        value={this.props.editComponent.flowConditionKey}
                                        type="select"
                                        onChange={this.props.onChange}
                                    >
                                        <option value={0}>DEMOGRAPHICS TYPE</option>
                                        {this.props.systemDemographics.map(item => (
                                            <option value={parseInt(item.ID)}>{item.type}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label> =
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Input
                                        className='mx-2'
                                        name="flowConditionValue"
                                        disabled={!this.canEdit}
                                        value={this.props.editComponent.flowConditionValue}
                                        type="select"
                                        onChange={this.props.onChange}
                                    >
                                        <option value={0}>DEMOGRAPHIC</option>
                                        {this.props.editComponent.flowConditionKey != null && this.props.editComponent.flowConditionKey > 0 && this.props.systemDemographics.filter(type => type.ID === parseInt(this.props.editComponent.flowConditionKey))[0].list.map(item => (
                                            <option value={parseInt(item.ID)}>{item.description}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Form>
                        </Row>
                        <Row className='my-2'>
                            <Input
                                type="select"
                                name="toID"
                                disabled={!this.canEdit}
                                value={this.props.editComponent.toID}
                                onChange={this.props.onChange}
                            >
                                <option value={-2}>Action</option>
                                <option value={0}>End Current Campaign and Resume Next</option>
                                <option value={-1}>End All Campaigns</option>
                                {this.props.marketingCampaigns.filter(campaign => campaign.active && campaign.campaignID !== this.props.campaign.campaignID).map(campaign => (
                                    <option value={campaign.campaignID}>Execute: {campaign.description}</option>
                                ))}
                            </Input>
                        </Row>
                        <Row className='my-2'>
                            <Input
                                type="textarea"
                                name="notes"
                                placeholder='Notes'
                                onChange={this.props.onChange}
                                disabled={!this.canEdit}
                                value={this.props.editComponent.notes}
                                rows={6}
                            />
                        </Row>
                        {this.props.checkPermission('Reassign Workflow Task') && <Row className='my-2'>
                            <Input
                                type="select"
                                name="auth0"
                                onChange={this.props.onChange}
                                // disabled={!this.canEdit}
                                value={this.props.editComponent.auth0}
                            >
                                <option value="">Default to Previous Assignee</option>
                                {this.props.users.map(user => (
                                    <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                                ))}
                            </Input>
                        </Row>}
                    </Col>
                    <Col md={3} className={`campaignFlowControls p-2 text-right my-2`}>
                        <Row>
                            <Col className=''>
                                {this.canEdit && <Button
                                    className="mx-1 mt-2"
                                    color="success"
                                    onClick={(e) => this.props.handleSaveComponent(e, 'isFlow', this.props.editComponent.order)}
                                    title="Save Component"
                                    disabled={
                                        this.props.editComponent.toID == null ||
                                        parseInt(this.props.editComponent.toID) === -2 ||
                                        (parseInt(this.props.editComponent.flowConditionKey) > 0 &&
                                            (this.props.editComponent.flowConditionValue == null || parseInt(this.props.editComponent.flowConditionValue) === 0)
                                        )
                                    }
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>}
                                {!this.canEdit && <Button
                                    className="mx-1 mt-2"
                                    color="success"
                                    onClick={(e) => this.props.handleSaveComponent(e, 'isFlow', this.props.editComponent.order)}
                                    title="Save Assignee"
                                    disabled={this.props.editComponent.auth0 === flowObj.auth0}
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>}
                                {this.canEdit && <ConfirmButton className="mx-1 mt-2 px-3" color="danger" onClick={this.props.handleDeleteComponent} title="Delete Component">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </ConfirmButton>}
                                <Button className="mx-1 mt-2 px-3" color="secondary" onClick={this.props.onCancelEditComponent} title="End Configure Component">
                                    <FontAwesomeIcon icon={faTimes} />
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='px-4 py-0 text-right'>
                                <Label><Input
                                    type="checkbox"
                                    name="active"
                                    disabled={!this.canEdit}
                                    onChange={this.props.onChange}
                                    checked={this.props.editComponent.active}
                                /> Active</Label>
                            </Col>
                        </Row>
                    </Col>
                </>
            }
        </Row>
    }

    displaySkip = (skipObj, isSubCampaign) => {
        return <Row key={skipObj.componentID} className='campaignComponent' onClick={() => this.props.onEditComponent(skipObj.componentID, isSubCampaign)}>
            {!isSubCampaign && this.props.editComponent.componentID === 0 && this.canEdit && <div className='campaignDragContainer'><FontAwesomeIcon icon={faGripLines} /></div>}
            {!isSubCampaign && this.props.editComponent.componentID > 0 && <div className='campaignDragContainer'><h3 className='m-0 p-0'>{skipObj.order / 10}</h3></div>}
            {this.props.editComponent.componentID !== skipObj.componentID ?
                <Col className={`campaignSkip ${!skipObj.active ? 'campaignInactive' : ''} my-${(isSubCampaign ? '1' : '2')} p-${(isSubCampaign ? '1 subCampaign' : '3')} ml-3`}>
                    {this.displayTitle(skipObj)}
                </Col>
                :
                <>
                    <Col className={`campaignSkipLogic ml-3 px-4 py-2 my-2`}>
                        <Row className='my-2'>
                            <Form inline>
                                <FormGroup>
                                    <Label>If
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Input
                                        className='mx-2'
                                        name="flowConditionKey"
                                        disabled={!this.canEdit}
                                        value={this.props.editComponent.flowConditionKey}
                                        onChange={this.props.onChange}
                                        style={{ minWidth: 450 }}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label> =
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <Input
                                            className='mx-2'
                                            name="flowConditionValue"
                                            type="radio"
                                            disabled={!this.canEdit}
                                            value="1"
                                            checked={this.props.editComponent.flowConditionValue === "1"}
                                            onChange={this.props.onChange}
                                        />Yes
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <Input
                                            className='mx-2'
                                            name="flowConditionValue"
                                            type="radio"
                                            disabled={!this.canEdit}
                                            value="0"
                                            checked={this.props.editComponent.flowConditionValue === "0"}
                                            onChange={this.props.onChange}
                                        />No
                                    </Label>
                                </FormGroup>
                            </Form>
                        </Row>
                        <Row className='my-2'>
                            <Input
                                type="select"
                                name="toID"
                                disabled={!this.canEdit}
                                value={this.props.editComponent.toID}
                                onChange={this.props.onChange}
                            >
                                <option value={-2}>Action</option>
                                <option value={-1}>End All Campaigns</option>
                                {this.props.campaign.components.filter(component => component.order > this.props.editComponent.order && !component.isSkip).map(component => (
                                    <option value={component.componentID}>Skip to step {component.order / 10} ({this.displayTitle(component, true)})</option>
                                ))}
                            </Input>
                        </Row>
                        <Row className='my-2'>
                            <Input
                                type="textarea"
                                name="notes"
                                placeholder='Notes'
                                onChange={this.props.onChange}
                                disabled={!this.canEdit}
                                value={this.props.editComponent.notes}
                                rows={6}
                            />
                        </Row>
                        {this.props.checkPermission('Reassign Workflow Task') && <Row className='my-2'>
                            <Input
                                type="select"
                                name="auth0"
                                onChange={this.props.onChange}
                                // disabled={!this.canEdit}
                                value={this.props.editComponent.auth0}
                            >
                                <option value="">Default to Previous Assignee</option>
                                {this.props.users.map(user => (
                                    <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                                ))}
                            </Input>
                        </Row>}
                        <Row className='my-2'>
                            <Form inline>
                                <FormGroup>
                                    <Input
                                        className='mr-2'
                                        name="reminder"
                                        disabled={!this.canEdit}
                                        value={this.props.editComponent.reminder}
                                        onChange={this.props.onChange}
                                        type="select"
                                    >
                                        <option>REMINDER</option>
                                        <option value={1}>1 Day</option>
                                        <option value={2}>2 Days</option>
                                        <option value={3}>3 Days</option>
                                        <option value={4}>4 Days</option>
                                        <option value={5}>5 Days</option>
                                        <option value={7}>1 Week</option>
                                        <option value={14}>2 Weeks</option>
                                        <option value={21}>3 Weeks</option>
                                        <option value={30}>1 Month</option>
                                        <option value={60}>2 Months</option>
                                        <option value={90}>3 Months</option>
                                        <option value={120}>4 Months</option>
                                        <option value={150}>5 Months</option>
                                        <option value={180}>6 Months</option>
                                        <option value={365}>1 Year</option>
                                        <option value={730}>2 Years</option>
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Input
                                        className='mx-2'
                                        name="snooze"
                                        disabled={!this.canEdit}
                                        value={this.props.editComponent.snooze}
                                        onChange={this.props.onChange}
                                        type="select"
                                    >
                                        <option>SNOOZE</option>
                                        <option value={1}>1 Day</option>
                                        <option value={2}>2 Days</option>
                                        <option value={3}>3 Days</option>
                                        <option value={4}>4 Days</option>
                                        <option value={5}>5 Days</option>
                                        <option value={7}>1 Week</option>
                                        <option value={14}>2 Weeks</option>
                                        <option value={21}>3 Weeks</option>
                                        <option value={30}>1 Month</option>
                                        <option value={60}>2 Months</option>
                                        <option value={90}>3 Months</option>
                                        <option value={120}>4 Months</option>
                                        <option value={150}>5 Months</option>
                                        <option value={180}>6 Months</option>
                                        <option value={365}>1 Year</option>
                                        <option value={730}>2 Years</option>
                                    </Input>
                                </FormGroup>
                            </Form>
                        </Row>
                    </Col>
                    <Col md={3} className={`campaignSkipControls p-2 text-right my-2`}>
                        <Row>
                            <Col className=''>
                                {this.canEdit && <Button
                                    className="mx-1 mt-2"
                                    color="success"
                                    onClick={(e) => this.props.handleSaveComponent(e, 'isSkip', this.props.editComponent.order)}
                                    title="Save Component"
                                    disabled={
                                        this.props.editComponent.toID == null ||
                                        parseInt(this.props.editComponent.toID) === -2 ||
                                        (parseInt(this.props.editComponent.flowConditionKey) > 0 &&
                                            (this.props.editComponent.flowConditionValue == null || parseInt(this.props.editComponent.flowConditionValue) === 0)
                                        )
                                    }
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>}
                                {!this.canEdit && <Button
                                    className="mx-1 mt-2"
                                    color="success"
                                    onClick={(e) => this.props.handleSaveComponent(e, 'isSkip', this.props.editComponent.order)}
                                    title="Save Assignee"
                                    disabled={this.props.editComponent.auth0 === skipObj.auth0}
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>}
                                {this.canEdit && <ConfirmButton className="mx-1 mt-2 px-3" color="danger" onClick={this.props.handleDeleteComponent} title="Delete Component">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </ConfirmButton>}
                                <Button className="mx-1 mt-2 px-3" color="secondary" onClick={this.props.onCancelEditComponent} title="End Configure Component">
                                    <FontAwesomeIcon icon={faTimes} />
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='px-4 py-0 text-right'>
                                <Label><Input
                                    type="checkbox"
                                    name="active"
                                    disabled={!this.canEdit}
                                    onChange={this.props.onChange}
                                    checked={this.props.editComponent.active}
                                /> Active</Label>
                            </Col>
                        </Row>
                    </Col>
                </>
            }
        </Row>
    }

    displaySubcampaignInfo = (flowObj) => {
        if (flowObj.toID === -1) {
            return {
                name: 'End All Campaigns',
                class: 'campaignFlowEndAll'
            }
        } else if (flowObj.toID === 0) {
            return {
                name: 'End Current Campaign and Resume Next',
                class: 'campaignFlowEndCurrent'
            }
        } else if (flowObj.toID > 0 && flowObj.flowConditionKey != null && flowObj.campaign != null) {
            return {
                name: flowObj.campaign.name,
                class: 'campaignFlowLogic'
            }
        } else if (flowObj.toID > 0 && flowObj.flowConditionKey == null && flowObj.campaign != null) {
            return {
                name: flowObj.campaign.name,
                class: 'campaignFlow'
            }
        } else {
            return {
                name: '',
                class: 'campaignFlow'
            }
        }
    }

    render() {
        const dragProps = {
            onDragEnd: (fromIndex, toIndex) => {
                const data = [...this.props.campaign.components];
                const item = data.splice(fromIndex, 1)[0];
                data.splice(toIndex, 0, item);
                this.props.reorder(data);
            },
            nodeSelector: 'div.campaignComponent',
            handleSelector: 'div.campaignDragContainer',
        };
        return (
            <Container className="text-left" fluid>
                <Modal isOpen={this.state.showModal} size="xl">
                    <ModalHeader toggle={() => this.setState({ showModal: false })}>
                        Workflow Help
                    </ModalHeader>
                    <ModalBody>
                        <Row className='my-2 border-bottom'>
                            <Col>
                                <p>A workflow is a predefined series of steps that can be applied to any company. Individual steps can consist of activities/tasks
                                    that must be completed by the individual they're assigned to. Delays or branching logic can also be added to give flexibility
                                    in the workflow, allowing for additional actions in response to specific conditions or responses by the assigned individual.
                                </p>
                                <p>Once defined, the order of workflow steps can be rearranged by dragging the handle to the left of each step.</p>
                            </Col>
                        </Row>
                        <Row className='my-2 border-bottom'>
                            <Col md={4}>
                                <Button
                                    block
                                    color="success"
                                    className='btn btn-lg font-weight-bold'
                                >Add Activity</Button>
                            </Col>
                            <Col>
                                <p>This function adds a step in the workflow process where the assigned individual needs to send an email, make a phone call or
                                    send an invitation. Once an activity type is selected, a dropdown menu will appear with available email, call or invitation
                                    templates to choose from. </p>
                                <p><strong>Notes</strong> — additional information related to this particular activity.</p>
                                <p><strong>Reminder</strong> — provides the ability to alert the assigned individual a specified number of days later to complete an unfinished task.</p>
                                <p><strong>Snooze</strong> — provides the ability for an assigned individual to pause the workflow for a specified number of days if needed; once
                                    set, the activity's deadline will shift in the workflow list.</p>
                            </Col>
                        </Row>
                        <Row className='my-2 border-bottom'>
                            <Col md={4}>
                                <Button
                                    block
                                    color="primary"
                                    className='btn btn-lg font-weight-bold'
                                >Add Delay</Button>
                            </Col>
                            <Col>
                                <p>This adds a delay of a specified number of days to a workflow; once the previous task is completed, the next task's deadline will shift
                                    forward by the selected delay amount.</p>
                                <p><strong>Notes</strong> — additional information related to this particular delay.</p>
                            </Col>
                        </Row>
                        <Row className='my-2 border-bottom'>
                            <Col md={4}>
                                <Button
                                    block
                                    color="warning"
                                    className='btn btn-lg font-weight-bold'
                                >Add Flow Step</Button>
                            </Col>
                            <Col>
                                <p>Adds logic to a workflow, so that when a particular company attribute equals a selected value, the workflow can either end (completing the
                                    workflow's set of tasks for that particular company) or it can branch into a separate workflow. Creating multiple "sub workflows" allows for
                                    more complex workflows that apply to certain scenarios, and can also be more easily reused.</p>
                                <p><strong>Demographics Type / Demographic</strong> — two optional dropdown menus that provide if/then logic to a workflow. If omitted, the action
                                    will take place regardless of circumstances.</p>
                                <p><strong>Action</strong> — the next process in the workflow (set as a separate workflow to enter in to) or the completion of the workflow.</p>
                                <p><strong>Notes</strong> — additional information related to this particular flow step.</p>
                            </Col>
                        </Row>
                        <Row className='my-2'>
                            <Col md={4}>
                                <Button
                                    block
                                    style={{ backgroundColor: '#fd7e14', borderColor: '#fd7e14' }}
                                    className='btn btn-lg font-weight-bold'
                                >Add Skip Step</Button>
                            </Col>
                            <Col>
                                <p>Inserts a yes/no question into a workflow, thereby allowing skipping ahead or backwards to other steps within the workflow. Once the
                                    assigned individual reaches this step, their answer will dictate what step in the workflow will occur next.
                                </p>
                                <p><strong>Action</strong> — a specific step within the current workflow to proceed to if the assigned individual makes an affirmative choice.</p>
                                <p><strong>Notes</strong> — additional information related to this particular activity.</p>
                                <p><strong>Reminder</strong> — provides the ability to alert the assigned individual a specified number of days later to complete an unfinished task.</p>
                                <p><strong>Snooze</strong> — provides the ability for an assigned individual to pause the workflow for a specified number of days if needed; once
                                    set, the activity's deadline will shift in the workflow list.</p>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal >
                <Row>
                    <Col>
                        <h2>Editing {this.props.campaign.name} {!this.props.campaign.active && '(Inactive)'}</h2>
                    </Col>
                    <Col md={2} className='text-right'>
                        <Button className="mx-1 mt-2" color="secondary" onClick={() => this.setState({ showModal: true })} title="Help">
                            <FontAwesomeIcon icon={faQuestionCircle} />
                        </Button>
                        <Button className="mx-1 mt-2" color="secondary" onClick={() => this.props.onToggleConfigureMarketingCampaign()} title="End Configure Campaign">
                            <FontAwesomeIcon icon={faTimes} />
                        </Button>
                    </Col>
                </Row>
                <Row>
                    {this.canEdit ? <Col md={9} className='pr-5'>
                        <ReactDragListView {...dragProps}>
                            {this.displayCampaignComponents(this.props.campaign, false)}
                        </ReactDragListView>
                    </Col> : <Col md={12} className='pr-5'>
                        {this.displayCampaignComponents(this.props.campaign, false)}
                    </Col>}
                    {this.canEdit && <Col>
                        <Button
                            block
                            color="success"
                            className='btn btn-lg my-4 font-weight-bold'
                            onClick={(e) => this.props.handleAddComponent(e, 'isActivity', ((this.props.campaign.components.length + 1) * 10))}
                        >Add Activity</Button>
                        <Button
                            block
                            color="primary"
                            className='btn btn-lg my-4 font-weight-bold'
                            onClick={(e) => this.props.handleAddComponent(e, 'isDelay', ((this.props.campaign.components.length + 1) * 10))}
                        >Add Delay</Button>
                        <Button
                            block
                            color="warning"
                            className='btn btn-lg my-4 font-weight-bold'
                            onClick={(e) => this.props.handleAddComponent(e, 'isFlow', ((this.props.campaign.components.length + 1) * 10))}
                        >Add Flow Step</Button>
                        <Button
                            block
                            style={{ backgroundColor: '#fd7e14', borderColor: '#fd7e14' }}
                            // color="info"
                            className='btn btn-lg my-4 font-weight-bold'
                            onClick={(e) => this.props.handleAddComponent(e, 'isSkip', ((this.props.campaign.components.length + 1) * 10))}
                        >Add Skip Step</Button>
                    </Col>}
                </Row>
            </Container>
        );

    }
}

export default Marketing2ConfigureCampaign;